import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Typography, Button } from '@mui/material';
import Link from '@mui/material/Link';
import TSButton from 'components/common/Button/Button';
import {
  signInWithRedirect,
  fetchAuthSession,
  signOut,
} from 'aws-amplify/auth';

import { ROUTES } from 'constants/RoutePaths';

import { decodeJWT } from 'aws-amplify/auth';

import { isUserAuth, userToken } from '_actions/user_actions';
import { setQRCodeId } from 'app/state';

import { useGetTrailCheckinQuery } from 'app/api/trailApiSlice';
import MLModal from 'components/common/Modal/Modal';
import LogActivity from 'pages/Protected/Activity/LogActivity';

const TrailCheckinDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const [isAuth, setIsAuth] = useState(false);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const { trailCheckinId } = useParams(); // Get trailId from URL parameters

  const QRCodeID = searchParams.get('QRCodeID');
  console.log('🚀 ~ TrailCheckinDetail ~ QRCodeID:', QRCodeID);

  if (QRCodeID) {
    dispatch(setQRCodeId(QRCodeID));
  }

  useEffect(() => {
    const checkAuth = async () => {
      const t = await userToken();
      setToken(t);
      setIsAuth(!!t);
    };
    checkAuth();
    setIsLoading(false);
  }, []);

  const handleSignIn = () => {
    const path = location.pathname + location.search;
    localStorage.setItem('postSignInPath', path);
    signInWithRedirect();
  };

  const handleCheckIn = (option) => {
    // Implement check-in logic here, e.g., call an API to log the check-in
    setSelectedOption(option);
    setIsModalOpen(true);
  };

  const toggleModal = (state) => {
    setIsModalOpen(state);
  };

  const {
    data: trailCheckin,
    isLoading: isLoadingLocations,
    error,
  } = useGetTrailCheckinQuery(trailCheckinId);

  if (error) {
    return (
      <div className="ts-page">
        {error.status === 404
          ? 'Check-in point not found.'
          : 'Error loading check-in point.'}
      </div>
    );
  }

  if (isLoading || isLoadingLocations) {
    return <div className="ts-page">Loading...</div>;
  } else {
    return (
      <>
        <div className="ts-page">
          <Typography className="py-2" variant="h2">
            {trailCheckin[0]?.checkinpointlocation}
          </Typography>
          <Typography className="py-2" variant="body1">
            You are at the checkin point {trailCheckin[0].checkinpointlocation}
            {trailCheckin[0]?.defaultstartpoint
              ? ' which is the default starting point the '
              : ' on '}
            the {trailCheckin[0]?.trailname} trail. From this point, you can
            explore the following routes, please select one to check in and let
            us know which way you are heading:
          </Typography>
          {isAuth ? (
            <div className="flex flex-col gap-2 max-w-md">
              {trailCheckin[0]?.trailoptions.length > 0 &&
                trailCheckin[0]?.trailoptions.map((option, index) => (
                  <TSButton
                    key={index}
                    btnText={option.TrailOptionName}
                    classList="py-4"
                    onClickFunc={() => handleCheckIn(option)}
                  />
                ))}
            </div>
          ) : (
            <div className="flex flex-col gap-2 max-w-md">
              <Typography variant="body1">
                Please sign in to see available trail options.
              </Typography>
              <TSButton
                btnText="Sign In"
                classList="py-4"
                onClickFunc={handleSignIn}
              />
            </div>
          )}

          <div className="px-4 py-2 flex items-center">
            <img
              src={require(
                `../../../../assets/LocationImages/${trailCheckin[0].mapimagelocation}`
              )}
              alt={`Map of ${trailCheckin[0].trailname}`}
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '400px',
                objectFit: 'cover',
              }}
            />
          </div>
          <Typography className="py-2" variant="body1">
            <Link
              href={trailCheckin[0]?.parksinfourl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </Link>{' '}
            to go to the Tasmania Parks and Wildlife website for more
            information.
          </Typography>
        </div>
        <MLModal open={isModalOpen} setOpenModal={setIsModalOpen}>
          <LogActivity
            option={selectedOption}
            isModal={true}
            toggleModal={setIsModalOpen}
            isCheckin={true}
            checkinPointDetails={trailCheckin[0]}
          />
        </MLModal>
      </>
    );
  }
};

export default TrailCheckinDetail;
